export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      {/* Top wave — About/Calculator (dark) → Services (dark, same family, subtle curve) */}
      <div className='services-wave-top'>
        <svg viewBox='0 0 1440 60' preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M0,30 C480,60 960,0 1440,30 L1440,0 L0,0 Z' fill='#fff' />
        </svg>
      </div>

      <div className='container'>
        <div className='row'>
          <div className='col-md-10 col-md-offset-1 section-title'>
            <h2>Our Services</h2>
            <p>
              We build efficient, sustainable solar systems that cut electricity bills for homes, businesses, and farms across India.
            </p>
          </div>
        </div>

        <div className='services-grid'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='service-card'>
                  <div className='service-icon-wrap'>
                    <i className={d.icon}></i>
                  </div>
                  <h3>{d.name}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : 'loading'}
        </div>
      </div>

      {/* Bottom wave — Services (dark) → Portfolio (light) */}
      <div className='services-wave-bottom'>
        <svg viewBox='0 0 1440 60' preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M0,20 C360,60 1080,0 1440,40 L1440,60 L0,60 Z' fill='var(--clr-bg)' />
        </svg>
      </div>
    </div>
  )
}
